<template>
<section class="talkWithGuideSection">
    <div class="talkWithGuide-Overlay" @click="toggleTalkWithGuideVisible"></div>
    <transition name="slide-down">
        <Box v-if="mounted">
            <component :is="currentSection" v-bind="props" />
        </Box>
    </transition>
</section>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Box from './TalkWithGuideBox.vue'
import Intro from './TalkWithGuideIntro.vue'
import Consent from './TalkWithGuideConsent.vue'
import Confirmation from './TalkWithGuideConfirmation.vue'
export default {
    components: {
        Box,
        Intro,
        Consent,
        Confirmation,
    },
    data() {
        return {
            currentSection: 'Intro',
            mounted: false
        }
    },
    computed: {
        ...mapState([]),
        props() {
            return {
                currentSection: this.currentSection,
                changeSection: this.changeSection,
            }
        }
    },
    methods: {
        ...mapActions([]),
        ...mapMutations([
            'toggleTalkWithGuideVisible'
        ]),
        changeSection(name) {
            this.currentSection = name
        }
    },
    mounted() {
        this.mounted = true
    }
}
</script>

<style lang="css"></style>
